<div id="recognition-file-upload-container" *ngIf="operatingCountryID && templateId">
    <div class="row">
        <div class="col-md-12">
            <div class="row pt-5">
                <div class="col-md-3 download-template__label">
                    {{'fileuploads.Template' |translate | translateKey}}
                 <span class="float-right">:</span>
                </div>
                <div class="col-md-8 download-template">
                    <span (click)="downloadTemplate()">
                        <i class="fa-icon fa text-primary fa-download pr-10"
                            title="{{'fileuploads.download'| translate | translateKey}}"></i>
                        {{'fileuploads.Download' | translate | translateKey}}
                        {{templateInfo.templateName}} {{'fileuploads.Template' |translate | translateKey}}
                    </span>
                </div>
            </div>
            <div class="row pt-5">
                <div class="col-md-3 upload-label">
                    {{'fileuploads.Select File' | translate | translateKey}} <span class="float-right">:</span>
                </div>
                <div class="col-md-8">
                    <label tabindex="0" (keyup.enter)="fileSelect.click()" for="attachFile"
                        class="btn btn-secondary choose-file__button"
                        title="{{'fileuploads.Choose File'| translate | translateKey}}">
                        <span aria-hidden="true">{{'fileuploads.Choose File'| translate | translateKey |
                            uppercase}}</span>
                        <input #fileSelect type="file" id="attachFile" ng2FileSelect [uploader]="uploader"
                            [disabled]="isFileUploading" (change)="onSelectFile($event.target.files, $event)" role="file" aria-label="browse"
                            style="display: none;" accept=".csv">
                    </label>
                </div>
            </div>
            <div class="row pt-5" *ngIf="uploader.queue.length > 0">
                <div class="col-md-3 upload-label">
                    {{'fileuploads.File Name' | translate | translateKey}} <span class="float-right">:</span>
                </div>
                <div class="col-md-8 word-break">
                    <label *ngFor="let item of uploader.queue">
                        {{item.file.name }}
                        <i class="fa fa-trash pl-2 fa-icon"
                            (click)="item.remove();fileSelect.value='';showDownloadErrorFile = false;"
                            title="{{'fileuploads.Delete'| translate | translateKey}}"></i>
                    </label>
                </div>
            </div>
            <div class="row pt-5" *ngIf="showDownloadErrorFile">
                <div class="col-md-10">
                    <a (click)="prepareDownloadErrorFile()">{{'fileuploads.Please click here to download error file, corresponding to your recent upload' | translate | translateKey }}</a>
                </div>
            </div>
            <div class="row pt-5">
                <div class="col-md-11">
                    <div class="drop-area">
                        <div ng2FileDrop (onFileDrop)="onSelectFile($event)" [uploader]="uploader"
                            class="text-center drop-box">
                            {{'fileuploads.Drag & Drop your file here' | translate | translateKey}}
                        </div>
                        <div class="pt-10">
                            <strong>{{'fileuploads.Supported File Format' |translate |
                                translateKey}}:&nbsp;.csv</strong><br />
                        </div>
                    </div>
                </div>
            </div>
            <div class="row text-right pr-15">
                <div class="col-md-11 pt-5 pb-5">
                    <button tabindex="0" type="button" (click)="uploadTemplate()"
                        [disabled]="!(isValidForm && uploader?.queue?.length && !isFileUploading)"
                        class="btn blue-button">
                        <span>{{'fileuploads.Upload' | translate | translateKey }}
                            <i *ngIf="isFileUploading" class="fa fa-spinner fa-spin"></i>
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/file-uploads/recognition-file-upload.component.html